<div [ngClass]="{'backend-env-session-test': isTestEnv}" class="blank-layout-container justify-content-center">
  <div class="position-relative row w-100 h-100">
    <div class="col-lg-7 col-xl-8 bg-gredient p-0 cc-xs-none cc-sm-none cc-md-none">
      <div class="p-0 h-100">
        <div class="align-items-center justify-content-center img-height d-none d-lg-flex"  style="background: #004c7a; border-bottom: 8px solid #6480bf; height: 40%;">
            <img src="assets/images/logos/clu-dark-logo.svg" class="align-middle m-2" alt="logo" style="position: absolute;bottom: 50px;max-width: 500px;" />
        </div>
      </div>
    </div>

    <div class="col-lg-5 col-xl-4 p-0" style="position: relative">
      <div class="p-32 d-flex align-items-start align-items-lg-center justify-content-center h-100" style="box-shadow : rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;">
        <div class="row justify-content-center w-100">
          <div class="col-lg-9 max-width-form">
            <div style="display: flex; padding: 20px;">
              <img src="assets/images/logos/cc-logo-noBG-min.png" alt="logo" style="width: 260px; margin: auto;">
            </div>
            <h4 class="f-w-700 f-s-24 m-0">{{ "Bienvenue sur votre plateforme" | translate }}</h4>
            <span class="f-s-14 d-block mat-body-1 m-t-8">{{ "Authentification - Workspace Admin" | translate }}</span>
            <form class="m-t-30" [formGroup]="form" (ngSubmit)="submit()">
              <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ "Société" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="w-100" color="primary">
                <input matInput [value]="appVersion.NOM_SOCIETE" [readonly]="true" />
              </mat-form-field>
              <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">{{ "Nom d'utilisateur" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="w-100" color="primary">
                <input matInput formControlName="Username" />
                <mat-hint *ngIf="f['Username'].touched && f['Username'].invalid" class="m-b-16 error-msg">
                  <div class="text-error" *ngIf="f['Username'].errors && f['Username'].errors['required']">
                    Le nom d'utilisateur est requis
                  </div>
                </mat-hint>
              </mat-form-field>
              <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block" >{{ "Mot de passe" | translate }}</mat-label>
              <mat-form-field appearance="outline" class="w-100" color="primary">
                <input matInput type="password" formControlName="Password" #passwordField/>
                <mat-hint *ngIf="f['Password'].touched && f['Password'].invalid" class="m-b-16 error-msg">
                  <div class="text-error" *ngIf="f['Password'].errors && f['Password'].errors['required']">
                    {{ "Le mot de passe est requis" | translate }}
                  </div>
                </mat-hint>
                <button mat-icon-button type="button" (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'" matSuffix>
                  <i-tabler *ngIf="passwordField.type === 'password'" name="eye" class="icon-20 d-flex"></i-tabler>
                  <i-tabler *ngIf="passwordField.type === 'text'" name="eye-off" class="icon-20 d-flex"></i-tabler>
                </button>
              </mat-form-field>
              <div class="error-container" *ngIf="!!errorText">{{ errorText | translate }}</div>
              <button mat-flat-button color="primary" class="w-100" [disabled]="!form.valid || loading">
                <ng-container *ngIf="loading"><mat-spinner diameter="25"></mat-spinner></ng-container>
                <ng-container *ngIf="!loading">{{ "Se connecter" | translate }}</ng-container>
              </button>
              <ng-container *ngIf="!!appVersion">
                <button mat-button type="button" class="w-100" [cdkCopyToClipboard]="appVersion.APP_VERSION_ID + ' | ' + appVersion.APP_VERSION_DISPLAY + (appVersion.APP_ENVIRONMENT != '' ? (' | ' + appVersion.APP_ENVIRONMENT) : '') + ' | ' + appVersion.APP_COMMIT_SHA">
                  {{ appVersion.APP_VERSION_ID + ' | ' + appVersion.APP_VERSION_DISPLAY + (appVersion.APP_ENVIRONMENT != '' && appVersion.APP_ENVIRONMENT != 'Production' ? (' | ' + appVersion.APP_ENVIRONMENT) : '') }}
                </button>
              </ng-container>
            </form>
          </div>
        </div>
      </div>
      <button mat-button (click)="doSwitchToProdEnvironment()" matTooltip="Quitter le mode TEST" *ngIf="isTestEnv" style="color: #FFF; position: absolute; right: 10px; top: 10px;" >
        <i-tabler name="external-link-off" class="icon-18"></i-tabler>
      </button>
    </div>
  </div>
</div>
